// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3TKj9","noInteraction":"EventWrapper_noInteraction__p0A-J","pointerPassthrough":"EventWrapper_pointerPassthrough__2yLrD"};